export const supportRoute = {
  en: '/support',
  fr: '/support',
};
